import { call, put, takeLatest } from "redux-saga/effects";
import { OP } from "../../constant";
import {
  doAddAgent,
  doFetchAgent,
  doViewAgent,
  doEditAgent,
  doDeactivateAgent,
  doApproveAgent,
  doRejectAgent,
  doActivateAgent,
  doGetAgentDetails,
  doGetAgentCommissionSummary,
  doGetAgentCommissions,
  doGetAgentCommissionsByDate,
} from "../../service/agent";

import errorMessage from "../../utils/error.json";

/* ------------------------- AGENT SAGA --------------------- */
// fetch agent list
function* fetchAgentTask(action) {
  try {
    yield put({ type: OP.AGENT_LIST_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(doFetchAgent, payload.token);

    if (res.status == 200) {
      yield put({
        type: OP.AGENT_LIST_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.AGENT_LIST_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.AGENT_LIST_FAILURE,
      payload: errMsg,
    });
  }
}

// add agent
function* addAgentTask(action) {
  try {
    yield put({ type: OP.ADD_AGENT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doAddAgent,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.ADD_AGENT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.ADD_AGENT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.ADD_AGENT_FAILURE,
      payload: errMsg,
    });
  }
}

// view agent
function* viewAgentTask(action) {
  try {
    yield put({ type: OP.VIEW_AGENT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doViewAgent,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.VIEW_AGENT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.VIEW_AGENT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.VIEW_AGENT_FAILURE,
      payload: errMsg,
    });
  }
}

// edit agent
function* editAgentTask(action) {
  try {
    yield put({ type: OP.EDIT_AGENT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doEditAgent,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.EDIT_AGENT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.EDIT_AGENT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.EDIT_AGENT_FAILURE,
      payload: errMsg,
    });
  }
}

// activate agent
function* activateAgentTask(action) {
  try {
    yield put({ type: OP.ACTIVATE_AGENT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doActivateAgent,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.ACTIVATE_AGENT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.ACTIVATE_AGENT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.ACTIVATE_AGENT_FAILURE,
      payload: errMsg,
    });
  }
}

// deactivate agent
function* deactivateAgentTask(action) {
  try {
    yield put({ type: OP.DEACTIVATE_AGENT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doDeactivateAgent,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.DEACTIVATE_AGENT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.DEACTIVATE_AGENT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.DEACTIVATE_AGENT_FAILURE,
      payload: errMsg,
    });
  }
}

// approve agent
function* approveAgentTask(action) {
  try {
    yield put({ type: OP.APPROVE_AGENT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doApproveAgent,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.APPROVE_AGENT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.APPROVE_AGENT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.APPROVE_AGENT_FAILURE,
      payload: errMsg,
    });
  }
}

// reject agent
function* rejectAgentTask(action) {
  try {
    yield put({ type: OP.REJECT_AGENT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doRejectAgent,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.REJECT_AGENT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.REJECT_AGENT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.REJECT_AGENT_FAILURE,
      payload: errMsg,
    });
  }
}

// get agent details
function* getAgentDetailsTask(action) {
  try {
    yield put({ type: OP.GET_AGENT_DETAILS_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doGetAgentDetails,
      payload.token,
      payload.data,
    );

    if (res.status === 200) {
      yield put({
        type: OP.GET_AGENT_DETAILS_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.GET_AGENT_DETAILS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.GET_AGENT_DETAILS_FAILURE,
      payload: errMsg,
    });
  }
}

// get agent commission summary
function* getAgentCommissionSummaryTask(action) {
  try {
    yield put({ type: OP.AGENT_COMMISSION_SUMMARY_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doGetAgentCommissionSummary,
      payload.token,
      payload.data,
    );

    if (res.status === 200) {
      yield put({
        type: OP.AGENT_COMMISSION_SUMMARY_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.AGENT_COMMISSION_SUMMARY_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.AGENT_COMMISSION_SUMMARY_FAILURE,
      payload: errMsg,
    });
  }
}

// get agent commissions
function* getAgentCommissionsTask(action) {
  try {
    yield put({ type: OP.AGENT_COMMISSIONS_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doGetAgentCommissions,
      payload.token,
      payload.data,
    );

    if (res.status === 200) {
      yield put({
        type: OP.AGENT_COMMISSIONS_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.AGENT_COMMISSIONS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.AGENT_COMMISSIONS_FAILURE,
      payload: errMsg,
    });
  }
}

// get agent commissions by date
function* getAgentCommissionsByDateTask(action) {
  try {
    yield put({ type: OP.AGENT_COMMISSIONS_BY_DATE_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doGetAgentCommissionsByDate,
      payload.token,
      payload.data,
    );

    if (res.status === 200) {
      yield put({
        type: OP.AGENT_COMMISSIONS_BY_DATE_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.AGENT_COMMISSIONS_BY_DATE_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.AGENT_COMMISSIONS_BY_DATE_FAILURE,
      payload: errMsg,
    });
  }
}

function* agentSaga() {
  yield takeLatest(OP.AGENT_LIST_REQUEST, fetchAgentTask);
  yield takeLatest(OP.ADD_AGENT_REQUEST, addAgentTask);
  yield takeLatest(OP.VIEW_AGENT_REQUEST, viewAgentTask);
  yield takeLatest(OP.EDIT_AGENT_REQUEST, editAgentTask);
  yield takeLatest(OP.ACTIVATE_AGENT_REQUEST, activateAgentTask);
  yield takeLatest(OP.DEACTIVATE_AGENT_REQUEST, deactivateAgentTask);
  yield takeLatest(OP.APPROVE_AGENT_REQUEST, approveAgentTask);
  yield takeLatest(OP.REJECT_AGENT_REQUEST, rejectAgentTask);
  yield takeLatest(OP.GET_AGENT_DETAILS_REQUEST, getAgentDetailsTask);
  yield takeLatest(OP.AGENT_COMMISSION_SUMMARY_REQUEST, getAgentCommissionSummaryTask);
  yield takeLatest(OP.AGENT_COMMISSIONS_REQUEST, getAgentCommissionsTask);
  yield takeLatest(OP.AGENT_COMMISSIONS_BY_DATE_REQUEST, getAgentCommissionsByDateTask);
}

export default agentSaga;
